import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "@/utils/trpc"

export const getSessionDetailOptions = (sessionId: string) =>
  trpcOptions.sessions.getSessionDetail.queryOptions({ sessionId })

export function useGetSessionDetail(sessionId: string) {
  return useQuery(getSessionDetailOptions(sessionId))
}
